<ul class="flex flex-col gap-2">
  @for (location of locations(); track location.id) {
    <li>
      <app-location-list-entry [location]="location">
        <app-location-description slot="description" [location]="location" />
        <div slot="end" class="sm:hidden">
          <a [routerLink]="['/organizations', organizationId(), 'locations', location.id]">
            <ui-button mode="outlined" [iconOnly]="true">
              <ng-icon name="heroArrowRight" size="20" class="!block" />
            </ui-button>
          </a>
        </div>
        <div slot="end" class="hidden sm:flex justify-center items-center">
          <a [routerLink]="['/organizations', organizationId(), 'locations', location.id]">
            <ui-button mode="outlined">
              {{ 'cockpit.locations.listEntry.detailsButton' | transloco }}
              <ng-icon name="heroArrowRight" size="20" slot="end" class="!block" />
            </ui-button>
          </a>
        </div>
      </app-location-list-entry>
    </li>
  }
</ul>
